import LanguageToggle from 'components/LanguageToggle';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { type SidebarUserInfo } from 'types/user';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { logout } from 'slices/loginSlice';
interface LandingHeaderProps {
  breakpoint: boolean;
}

const LandingHeader: React.FC<LandingHeaderProps> = ({ breakpoint }) => {
  const [isOpen, setIsOpen] = useState(false);
  const userInfo: SidebarUserInfo | null = useSelector((state: RootState) => state.loginSlice.userInfo);
  const dispatch = useDispatch();
  const nav = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const onClickLogoutButton = () => {
    dispatch(logout());
    nav('/login');
  };

  return (
    <header
      className={`${
        breakpoint
          ? 'bg-[linear-gradient(rgb(255,255,255),rgba(255,255,255,0))] text-black'
          : 'bg-[linear-gradient(rgb(0,0,0),rgba(0,0,0,0))] text-white'
      } ${isOpen && breakpoint ? 'bg-white' : ''} fixed z-50 flex w-full transform justify-between py-7`}
    >
      <div className="flex items-center gap-5">
        <a href="/" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0}); }}>
          <img 
            className="h-[26px] w-[102] pl-5" 
            src={breakpoint ? "/iopsspace.png" : "/iopsspace_white.png"} 
            alt="Logo" 
          />
        </a>
        <div className="hidden gap-2 font-regular lg:flex">
          <a
            className={`transform rounded-full px-4 py-1 duration-300 ${breakpoint ? 'hover:bg-[rgba(0,0,0,0.1)]' : 'hover:bg-[rgba(255,255,255,0.3)]'}`}
            href="#overview"
          >
            Overview
          </a>
          <a
            className={`transform rounded-full px-4 py-1 duration-300 ${breakpoint ? 'hover:bg-[rgba(0,0,0,0.1)]' : 'hover:bg-[rgba(255,255,255,0.3)]'}`}
            href="#benefits"
          >
            Benefits
          </a>
          <a
            className={`transform rounded-full px-4 py-1 duration-300 ${breakpoint ? 'hover:bg-[rgba(0,0,0,0.1)]' : 'hover:bg-[rgba(255,255,255,0.3)]'}`}
            href="#features"
          >
            Features
          </a>
          <a
            className={`transform rounded-full px-4 py-1 duration-300 ${breakpoint ? 'hover:bg-[rgba(0,0,0,0.1)]' : 'hover:bg-[rgba(255,255,255,0.3)]'}`}
            href="#contact"
          >
            Contact
          </a>
          <a
            className={`transform rounded-full px-4 py-1 duration-300 ${breakpoint ? 'hover:bg-[rgba(0,0,0,0.1)]' : 'hover:bg-[rgba(255,255,255,0.3)]'}`}
            href="/promotion"
          >
            Promotion
          </a>
          <a
            className={`transform rounded-full px-4 py-1 duration-300 ${breakpoint ? 'hover:bg-[rgba(0,0,0,0.1)]' : 'hover:bg-[rgba(255,255,255,0.3)]'}`}
            href="/spacetime-tools"
          >
            SpaceTime Tools
          </a>
        </div>
      </div>
      <div className="hidden gap-4 lg:flex pr-5">
        <LanguageToggle/>
        <div className='flex justify-center items-center '>
        {userInfo ? (
          <button
            onClick={onClickLogoutButton}
            className={`fade-right delay-800 ${breakpoint ? 'bg-black text-white' : 'bg-white text-black'} duration-300.5 transform rounded-full px-4 py-1 font-regular`}
          >
            LogOut
          </button>
        ) : (
          <Link to={'/login'}>
            <button
              className={`fade-right delay-800 ${breakpoint ? 'bg-black text-white' : 'bg-white text-black'} duration-300.5 transform rounded-full px-4 py-1 font-regular`}
            >
              LogIn
            </button>
          </Link>
        )}
        </div>
      </div>

      <div className="relative pr-5 lg:hidden">
        <button
          className={`${isOpen ? 'gap-[18px]' : 'gap-[10px]'} relative flex h-10 w-10 transform flex-col items-center justify-center duration-300`}
          onClick={toggleMenu}
        >
          <span
            className={`block h-[2px] w-6 bg-[#999999] transition-transform duration-300 ${
              isOpen ? 'translate-y-2.5 rotate-45' : ''
            }`}
          />
          <span
            className={`block h-[2px] w-6 bg-[#999999] transition-transform duration-300 ${
              isOpen ? '-translate-y-2.5 -rotate-45' : ''
            }`}
          />
        </button>
      </div>

      {isOpen && (
        <div
          className={`${breakpoint ? 'bg-white' : 'bg-black'} ${
            isOpen ? 'h-[360px]' : 'h-0'
          } absolute top-[79px] block w-full overflow-hidden py-6 transition-all lg:hidden`}
        >
          <div className="flex flex-col items-center justify-center gap-4">
            <a
              className={`fade-right transform rounded-full px-4 py-1 hover:bg-[rgba(0,0,0,0.1)]`}
              href="#overview"
            >
              Overview
            </a>
            <a
              className={`fade-right delay-201 transform rounded-full px-4 py-1 hover:bg-[rgba(0,0,0,0.1)]`}
              href="#benefits"
            >
              Benefits
            </a>
            <a
              className={`fade-right delay-400 transform rounded-full px-4 py-1 hover:bg-[rgba(0,0,0,0.1)]`}
              href="#features"
            >
              Features
            </a>
            <a
              className={`fade-right delay-600 transform rounded-full px-4 py-1 hover:bg-[rgba(0,0,0,0.1)]`}
              href="#contact"
            >
              Contact
            </a>
            <a
              className={`fade-right delay-600 transform rounded-full px-4 py-1 hover:bg-[rgba(0,0,0,0.1)]`}
              href="/promotion"
            >
              Promotion
            </a>
            <a
              className={`fade-right delay-600 transform rounded-full px-4 py-1 hover:bg-[rgba(0,0,0,0.1)]`}
              href="/spacetime-tools"
            >
              SpaceTime Tools
            </a>
            <div>
            <LanguageToggle/>
              <div className="mt-5 flex w-full items-center justify-center">
                {userInfo ? (
                  <button
                    onClick={onClickLogoutButton}
                    className={`fade-right delay-800 ${breakpoint ? 'bg-black text-white' : 'bg-white text-black'} duration-300.5 transform rounded-full px-4 py-1 font-regular`}
                  >
                    LogOut
                  </button>
                ) : (
                  <Link to={'/login'}>
                    <button
                      className={`fade-right delay-800 ${breakpoint ? 'bg-black text-white' : 'bg-white text-black'} duration-300.5 transform rounded-full px-4 py-1 font-regular`}
                    >
                      LogIn
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default LandingHeader;

